import { FC } from 'react';
import { QuerySwitch } from 'components/QuerySwitch';
import {
  SeniorityRankingDataContext,
  SeniorityRankingDataProvider,
} from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.data.context';
import { SeniorityRankingFormProvider } from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.form.context';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';
import { useSelector } from 'react-redux';
import { SeniorityRankingTabReadView } from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.read';
import { SeniorityRankingTabEditView } from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.edit';

export const SeniorityRankingFormTab: FC = () => {
  const isUserSecondary = useSelector(isUserSecondarySelector);
  if (isUserSecondary) {
    return <SeniorityRankingTabReadView />;
  }

  return (
    <SeniorityRankingFormProvider>
      <SeniorityRankingTabEditView />
    </SeniorityRankingFormProvider>
  );
};

export const SeniorityRankingPage: FC = () => {
  return (
    <SeniorityRankingDataProvider>
      <QuerySwitch context={SeniorityRankingDataContext} component={SeniorityRankingFormTab} />
    </SeniorityRankingDataProvider>
  );
};
